import {reader} from "messaging/reader.js";
import {parse, getCycleString} from 'effects/midi/tidal/parser.js';
import {tparse} from './tidal.js'
import {publish} from "messaging/queue.js";
import {doc} from './documentation.js';
import StepData from 'pattern/StepData.js';
import {trigger, filter, lazy} from './lang.js';
import {trig} from './trig.js';

const DEFAULT_STEP = new StepData();

// sends tidal pattern (basically doont skip emmpty)
export const t_send = (type, value) => {
    let lastValue = undefined;
    return (... args) => {
        let [stepData, time, stepNumber] = args;
        let _value = lazy(value, ...args);
        if (!lastValue || _value !== lastValue) {
            let _type = lazy(type, ...args);
            let _value = lazy(value, ...args);
            publish(_type, _value);
            lastValue = _value;
        } 
        return filter(true);
    };
};

export const send = (type, value, skipEmpty=true) => {
    return (... args) => {
        let [stepData, time, stepNumber] = args;
        if (stepData || !skipEmpty) {
            let _type = lazy(type, ...args);
            let _value = lazy(value, ...args);
            publish(_type, _value);
        }
        return filter(true);
    };
};

doc(
    "receive",
    {
        "type":"",
        "fn":"",
        "skipEmpty":"",
    },
    "Reads messages of given type returning the values");
export const receive = (type, fn, skipEmpty=true, createStep=true) => {
    let _reader = reader(type, true);
    let last = undefined;

    return (... args) => {
        let stepData = args[0] && args[0].track ? args[0] : undefined;
        if (!stepData && skipEmpty) {
            // dont read unless we have a trigger here
            return undefined; 
        }
        let msgs = _reader();
        if (fn) {
            if (msgs.length > 0 && stepData === undefined && createStep) {
                let effect = args[3];
                let _stepData = effect.getStep(DEFAULT_STEP);
                _stepData.track = effect.track;
                args = [_stepData, ...args.slice(1)];
            } 
            let r = msgs.map((value) => {
                if (typeof fn === "function") {
                    return lazy(fn(value), ...args);
                } else {
                    // in the case of receive("msg", chop(5))
                    // chop(5) expands to an axiom
                    return fn;
                }
            });
            let x = r[0] || trig(args);
            return x;
        }
        let ret = msgs.length === 0 ? last : msgs;
        if (msgs.length > 0) {
            last = msgs;
        }
        return ret[0];
    };
};

export const t_receive = (type, fallback=tparse("[0]")) => {
    let _reader = reader(type, true);
    let last = undefined;
    return (...args) => {
        let msgs = _reader();
        let ret = (msgs.length === 0 ? last : msgs[0]) || lazy(fallback, ...args);
        if (msgs.length > 0) {
            last = msgs[0];
        }
        return ret;
    };
};
